module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": require("../../assets/posters/findingHome.jpg")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fk__project__top__netflix",
    attrs: {
      "href": "https://www.netflix.com/title/80109146"
    }
  }, [_c('img', {
    staticClass: "fk__project__top__netflix__image",
    attrs: {
      "src": require("../../assets/now-on-netflix.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Finding Home")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2014")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Full Length Documentary / Rapha House")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("No child deserves to be trafficked. No child deserves to be sexually exploited. Rapha House’s vision is to see children living safely in communities without the threats of trafficking and sexual exploitation.")]), _vm._v(" "), _c('p', [_vm._v("Finding Home is a gripping documentary following the lives of three young Cambodian women who were victims of sex trafficking at a young age. Through three years of filming their post trafficking experiences, the film allows these young women to reveal their stories with dignity. The viewer will see the devastation and heartache of these tragic stories, but will also experience hope and joy as they journey with these young women on a path from victim to survivor. Finding Home reminds us that we are all connected in our humanity; that we are all looking for a place of love, acceptance and community. A place called home.")]), _vm._v(" "), _c('p', [_vm._v("*This project was done under the name Flying Treasure which is creative lead Derek Hammeke's company.  The Rapha House organization plans to continue work with Famous King in the future.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.netflix.com/title/80109146"
    }
  }, [_c('img', {
    staticClass: "fk__project__netflix-banner",
    attrs: {
      "src": require("../../assets/large-netflix.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f00ac7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/FindingHome.vue
// module id = 73
// module chunks = 0